import React from 'react';
import {string} from 'prop-types';
import {injectIntl, intlShape} from 'react-intl';
import classNames from 'classnames';

import config from '../../config';

import {getEventProps} from './EventContactInfo.helpers';
import css from './EventContactInfo.module.css';

const EventContactInfo = (props) => {
  const {
    className,
    eventType,
    intl,
  } = props;
  const eventProps = getEventProps(eventType);
  const infoText = intl.formatMessage({id: eventProps.id});
  const phoneText = intl.formatMessage({id: 'EventContactInfo.phone'});
  const mailText = intl.formatMessage({id: 'EventContactInfo.mail'});
  const classes = classNames(css.root, className);

  return (
    <div className={classes}>
      <img className={css.img} src={eventProps.img} alt={eventProps.alt}/>
      <div className={css.infoContainer}>
        <span className={css.negociatedOfferInfo}>
        {intl.formatMessage({id: 'SearchPage.EventNegociatedOffer'})}
        </span>
        <span className={css.info}>{infoText}</span>
        <a
          href={config.custom.openTicketLink}
          target="_blank"
          rel="noopener noreferrer"
          className={css.helpLink}
        >
  {intl.formatMessage({ id: 'SearchPage.helpText' })}
</a>
      </div>
    </div>
  )
}

EventContactInfo.defaultProps = {
  className: null,
  eventType: null,
};

EventContactInfo.propTypes = {
  className: string,
  eventType: string,
  intl: intlShape.isRequired,
};

export default injectIntl(EventContactInfo);
